export class MockMsalGuard {
  canActivate() {
    return true;
  }
}
